module.exports = __webpack_public_path__ + "img/checkboxEle.b753b924.svg";